import React, {useState} from "react";
import {Button, Modal} from "semantic-ui-react";
import agent from "../../agent";

interface Props {
    onDelete: () => Promise<void>;
    onClose: (success: Boolean) => void;
}

const AppListDeleteModal = (props: Props) => {
    const [saving, setSaving] = useState(false);

    return (
        <Modal size={"small"}
               dimmer={"blurring"}
            onClose={() => props.onClose(false)}
            open
            closeIcon>
            <Modal.Header>Удалить отмеченную запись?</Modal.Header>
            <Modal.Content>
                <p>
                    Вы действительно хотите удалить отмеченную запись?
                </p>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    content={"Удалить"}
                    disabled={saving}
                    onClick={async () => {
                        setSaving(true);
                        try {
                            await props.onDelete();
                            props.onClose(true);
                        } finally {
                            setSaving(false);
                        }
                    }}
                    positive
                />
                <Button
                    color={'grey'}
                    disabled={saving}
                    onClick={() => props.onClose(false)}>
                    Отмена
                </Button>
            </Modal.Actions>
        </Modal>);
}

export default AppListDeleteModal;